/**
*
*   Signup Footer
*       - The Signup Area on the Footer
*
**/
'use client';

import Config from '@/config';
import Button from '@/components/button';
import Article from '@/libraries/article';
import { useTranslations } from 'next-intl';
import { Link } from '@/libraries/navigation';


//Build the Element
export default function Tags({ article, ...props }){

    const t = useTranslations();

    //Show Coming Soon
    const ComingSoon = ({ children , href }) => (
        <a data-href={ href } disabled onClick={ (e) => e.preventDefault() }>
            <span>{ children }</span>
            <div className="box">
                Coming Soon!
            </div>
        </a>
    );

    //Return
    return (
        <section id="explore" className="container">
            <div>
                <div>
                    <h5>
                        { t('Pages.Blog.explore') }
                    </h5>
                    <div className="list">
                        <nav>
                            <ul>
                                <li>
                                    <Link href="/blog/farming-and-culture">
                                        <strong>{ t('Pages.Blog.categories.farming-and-culture') }</strong>
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/blog/farming-and-culture/tagged/meet-the-farmer">
                                        { t('Pages.Blog.categories.meet-the-farmer') }
                                    </Link>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/farming-and-culture/tagged/sourcing-and-quality">
                                        { t('Pages.Blog.categories.sourcing') }
                                    </ComingSoon>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/farming-and-culture/tagged/environment">
                                        { t('Pages.Blog.categories.environment') }
                                    </ComingSoon>
                                </li>
                                <li>
                                    <Link href="/blog/farming-and-culture/tagged/our-story">
                                        { t('Pages.Blog.categories.our-story') }
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                        <nav>
                            <ul>
                                <li>
                                    <ComingSoon href="/blog/education">
                                        <strong>{ t('Pages.Blog.categories.education') }</strong>
                                    </ComingSoon>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/education/tagged/introduction">
                                        { t('Pages.Blog.categories.introduction') }
                                    </ComingSoon>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/education/tagged/courses">
                                        { t('Pages.Blog.categories.courses') }
                                    </ComingSoon>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/education/tagged/uses-and-benefits">
                                        { t('Pages.Blog.categories.uses-and-benefits') }
                                    </ComingSoon>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/education/tagged/safety">
                                        { t('Pages.Blog.categories.safety') }
                                    </ComingSoon>
                                </li>
                            </ul>
                        </nav>
                        <nav>
                            <ul>
                                <li>
                                    <Link href="/blog/recipes">
                                        <strong>{ t('Pages.Blog.categories.recipes') }</strong>
                                    </Link>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/recipes/tagged/blends-and-oils">
                                        { t('Pages.Blog.categories.blends-and-oils') }
                                    </ComingSoon>
                                </li>
                                <li>
                                    <Link href="/blog/recipes/tagged/all-natural-diy">
                                        { t('Pages.Blog.categories.all-natural-diy') }
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                        <nav>
                            <ul>
                                <li>
                                    <Link href="/blog/community">
                                        <strong>{ t('Pages.Blog.categories.community') }</strong>
                                    </Link>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/community/tagged/local-spotlight">
                                        { t('Pages.Blog.categories.local-spotlight') }

                                    </ComingSoon>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/community/tagged/events">
                                        { t('Pages.Blog.categories.events') }
                                    </ComingSoon>
                                </li>
                            </ul>
                        </nav>
                        <nav>
                            <ul>
                                <li>
                                    <Link href="/blog/impact">
                                        <strong>{ t('Pages.Blog.categories.impact') }</strong>
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/blog/impact/tagged/mission-goals">
                                        { t('Pages.Blog.categories.mission-and-goals') }
                                    </Link>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/impact/tagged/awareness">
                                        { t('Pages.Blog.categories.awareness') }
                                    </ComingSoon>
                                </li>
                                <li>
                                    <ComingSoon href="/blog/impact/tagged/awards">
                                        { t('Pages.Blog.categories.awards') }
                                    </ComingSoon>
                                </li>
                            </ul>
                        </nav>
                        <nav>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    );

}